/* eslint-disable */
import { useState, useEffect } from "react";
import { Link, useLocation } from "wouter";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Products", href: "/products" },
  { label: "Gift Cards", href: "/gift-cards" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <header
      data-testid="site-navigation"
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-spa-cream/85 backdrop-blur-xl border-b border-spa-border"
          : "bg-spa-cream/60 backdrop-blur-md"
      }`}
    >
      <div className="container-spa flex items-center justify-between h-24">
        <Link href="/" data-testid="nav-logo-link">
          <div className="cursor-pointer">
            <Logo variant="default" size="md" />
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => {
            const active = location === link.href;
            return (
              <Link
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span
                  className={`font-sans text-sm cursor-pointer transition-colors relative ${
                    active ? "text-spa-green" : "text-spa-dark hover:text-spa-green"
                  }`}
                >
                  {link.label}
                  {active && (
                    <span className="absolute -bottom-1.5 left-0 right-0 h-px bg-spa-cyan" />
                  )}
                </span>
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:block">
          <Link href="/services" data-testid="nav-cta-book">
            <button className="btn-primary text-sm py-2.5 px-6">Book a Massage</button>
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-spa-dark"
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-spa-border bg-spa-cream" data-testid="nav-mobile-menu">
          <div className="container-spa py-6 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                data-testid={`nav-mobile-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="block py-3 text-spa-dark hover:text-spa-green border-b border-spa-border/60">
                  {link.label}
                </span>
              </Link>
            ))}
            <Link href="/services" data-testid="nav-mobile-cta-book">
              <button className="btn-primary w-full mt-4">Book a Massage</button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
